export const inputClass =
  "w-full px-4 py-3 rounded-lg border border-Secondary/30 bg-DarkBg2 text-Background focus:outline-none focus:border-Primary placeholder:text-GrayCustom/50";
export const labelClass = "text-sm font-medium text-Background mb-1";
export const cardClass =
  "w-full flex flex-col gap-4 p-6 rounded-2xl border border-Secondary/20 bg-DarkBg10";
export const btnPrimary =
  "flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-Primary text-white hover:bg-Primary_Accents_md disabled:opacity-50 transition-colors text-sm font-medium";
export const btnOutline =
  "flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-Primary text-Primary hover:bg-Primary hover:text-white disabled:opacity-50 transition-colors text-sm font-medium";
